/*
 * サブシステム名：
 * 定型コース登録(package版)
 * 表示項目カスタマイズ(滋賀自工)
 */
import D2MSTD0460 from '@/views/MST/D2MSTD0460.js'
import d2fmt from '@/ddv2.library/utils/formatter'

export default {
  extends: D2MSTD0460,
  name: 'MstTeikeiCorceEditCustomForHNU',
  data: () => ({
  }),
  computed: {
  },
  methods: {
    onCalcWithoutTax: function () {
      // 高速道路料から税分を減算
      let unchinHokaKingaku = this.rec.unchinHokaKingaku || 0
      unchinHokaKingaku = d2fmt.removeComma(unchinHokaKingaku)
      const calcKingaku = Math.round(unchinHokaKingaku / 1.1)
      this.$set(this.rec, 'unchinHokaKingaku', calcKingaku)
    }
  }
}
